/** The signed-in user's line, provisioned by the server from OIDC identity + users.yaml. */

export interface Me {
  user: { email: string; name: string };
  line: { extension: string; domain: string; callerId: string; callerIdDisplay: string };
  sip: { server: string; domain: string; username: string; realm: string; ha1: string; displayName: string };
}

export type AccountState =
  | { status: 'loading' }
  | { status: 'ready'; me: Me }
  | { status: 'not_provisioned' | 'extension_disabled'; email: string }
  | { status: 'error'; message: string };

export function login(): void {
  const returnTo = window.location.pathname + window.location.search;
  window.location.assign(`/auth/login?returnTo=${encodeURIComponent(returnTo)}`);
}

export function logout(): void {
  window.location.assign('/auth/logout');
}

/** Fetch /api/me; redirects to sign-in when there's no session. */
export async function fetchAccount(): Promise<AccountState> {
  let res: Response;
  try {
    res = await fetch('/api/me', { credentials: 'same-origin', cache: 'no-store' });
  } catch {
    return { status: 'error', message: 'Cannot reach NGN Phone. Check your connection.' };
  }
  if (res.status === 401) {
    login();
    return { status: 'loading' };
  }
  const body = await res.json().catch(() => ({}));
  if (res.status === 403 && (body.error === 'not_provisioned' || body.error === 'extension_disabled')) {
    return { status: body.error, email: body.user?.email ?? '' };
  }
  if (!res.ok) return { status: 'error', message: `Unexpected error (${res.status}).` };
  return { status: 'ready', me: body as Me };
}
